module.exports = __webpack_public_path__ + "d5e590eff8349ff107ce3d71ef11aeb6.png";